export default __webpack_public_path__ + "static/media/oliver-about-us.b94d36ed.jpg";